module.exports = __webpack_public_path__ + "img/tick-big.c7e8b7a3.svg";